<template>
  <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
    <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
  </v-overlay>
  <v-app id="app_lead_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">NEW VISITS FOR APPROVALS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Review new visit request data & approve.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()" style="border-radius: 2px;">
              <v-icon size="x-large">mdi-menu-left</v-icon> BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-card class="custom_card_box mt-8" elevation="1" style="border-radius: 2px; border: 1px solid rgba(0,0,0,0.1);">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class=" custom_pdf_btn" variant="outlined" @click="exportPDF" style="border-radius: 2px;">
            <v-icon size="large">mdi-file-pdf</v-icon>  PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel" style="border-radius: 2px;">
            <v-icon size="large">mdi-file-excel</v-icon>  Excel
          </v-btn>
        </v-card-text>
        <v-divider thickness="2"></v-divider>
        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="3">
              <v-text-field
                v-model="mainSearch"
                append-inner-icon="mdi-magnify"
                label="Search New Visits"
                placeholder="Search in all fields"
                variant="outlined"
                density="comfortable"
                hide-details
                clearable
                class="custom_input_field_color"
                style="border-radius: 2px;"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-date-input 
                v-model="assignDate" 
                @click:append-inner="clearAssignDate" 
                append-inner-icon="mdi-close"
                label="Assign Date" 
                prepend-inner-icon="$calendar"
                multiple="range"
                prepend-icon="" 
                placeholder="Select Date Range" 
                variant="outlined" 
                density="comfortable"
                hide-details
                class="custom_input_field_color"
              ></v-date-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.salesRep_name"
                :items="uniqueSalesReps"
                label="Sales Rep"
                placeholder="Select Rep"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.area_code"
                :items="uniqueAreas"
                label="Area"
                placeholder="Select Area"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="mt-4"></v-divider>
          <v-data-table 
            v-model:page="page" 
            v-model:items-per-page="itemsPerPage" 
            :headers="headers" 
            :items="filteredItems" 
            :loading="loading" 
            :items-per-page-options="[{value: 10, title: '10'}, {value: 25, title: '25'}, {value: 50, title: '50'}, {value: 100, title: '100'}, {value: -1, title: 'All'}]"
            class="custom_table_normal mt-2"
            item-key="unique_key"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_product_list">
                <template v-slot:activator="{ props }">
                  <v-btn 
                    style="background-color: #800080; color: white; border-radius: 2px;" 
                    variant="flat" 
                    size="large" 
                    v-bind="props">
                    ACTIONS   
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list style="border-radius: 2px;">
                  <v-list-item v-if="permissions.read" @click="viewItem(item)">
                    <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.read" @click="openApproveDialog(item)">
                    <v-list-item-title style="color: #4CAF50; font-weight: 500;">APPROVE</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.read" @click="openRejectDialog(item)">
                    <v-list-item-title class="custom_font_color_delete">REJECT</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                    <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="view_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn
                variant="flat"
                style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px;"
                @click="view_leads_dialog = false"
              >
                CLOSE
              </v-btn>
          </v-toolbar>
          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog" v-if="selectedLead">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">NEW VISIT DETAILS</v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" style="border-radius: 2px;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="2" lg="1" xl="1">
                        <v-img
                            :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')"
                            aspect-ratio="1" class="user_image_view"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="10" lg="11" xl="11">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Sales Rep name:
                             </p>
                          <p class="font-weight-bold custom_page_component_main_title ml-1"
                             style="color: #05146F !important;">{{ selectedLead.salesRep_name }}</p>
                        </div>
                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile:  </p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1 ml-1" style="color: #05146F !important;">
                            {{ selectedLead.sales_rep_mobile || 'N/A' }}</p>
                        </div>
                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">New Visit Title:  </p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1 ml-1">
                            {{ selectedLead.lead_title }}</p>
                        </div>
                        <div class="d-flex mt-4">
                          <v-chip class="custom_green_chip" variant="outlined" style="border-color: #4CAF50; color: #4CAF50; border-radius: 2px;">
                            <v-icon size="small" class="mr-1">mdi-check-circle-outline</v-icon>
                            NEW VISIT REQUEST FROM SALES REP
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mb-4 mt-2"></v-divider>
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.institute_name" density="comfortable"
                        class="px-3 custom_input_field_class_view custom_input_field_color" label="Institute Name"
                        readonly variant="outlined"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.area_code" density="comfortable"
                        class="px-3 custom_input_field_class_view custom_input_field_color" label="Area Code"
                        readonly variant="outlined"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-text-field
                        :model-value="formatCleanText(selectedLead.lead_status)" density="comfortable"
                        class="px-3 custom_input_field_class_view custom_input_field_color" label="Status"
                        readonly variant="outlined"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-text-field
                        v-model="selectedLead.assign_date" density="comfortable"
                        class="px-3 custom_input_field_class_view custom_input_field_color" label="Assign Date"
                        readonly variant="outlined"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <div class="px-3 mb-4 mt-2">
                      <p class="custom_page_main_sub_title">Description</p>
                      <v-divider class="mt-3 mb-4"></v-divider>
                      <v-card color="#F7F7F7" flat border="sm opacity-1" outlined density="comfortable" style="border-radius: 2px;">
                        <v-card-text>
                          <div v-html="getSanitizedHTML(selectedLead.discription)"
                               class=" ml-3 ql-container ql-snow"></div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-1 mb-3"></v-divider>
                    <p class="custom_page_main_sub_title">
                      <strong>SELECTED NEW VISITS LIST</strong>
                    </p>
                    <p class="custom_page_main_sub_title mt-2 mb-4" style="opacity: 0.6">
                      The following table shows the selected institute related to this new visit.
                    </p>
                    
                    <v-card class="mt-4 mb-4 custom_card_box" elevation="1" border="sm opacity-1" style="border-radius: 2px;">
                      <v-card-text>
                        <v-data-table 
                          :headers="headers_two" 
                          :items="selectedLead.selected_leads || []"
                          :items-per-page="-1" 
                          density="default"
                          class="custom_table_normal">
                          <template v-slot:bottom></template>
                          <template v-slot:[`item.visited_status`]="{ item }">
                            <v-chip 
                              v-if="item.visited_status === 'VISITED' || item.visited_status === 'COMPLETED'" 
                              class="custom_green_chip" 
                              size="small" 
                              variant="outlined" style="border-radius: 2px;">
                              <v-icon>mdi-check-circle-outline</v-icon>  {{ formatCleanText(item.visited_status) }}
                            </v-chip>
                            <v-chip v-else 
                                    class="custom_red_chip" 
                                    size="small" 
                                    variant="outlined" style="border-radius: 2px;">
                              <v-icon>mdi-close</v-icon>  {{ formatCleanText(item.visited_status || 'PENDING') }}
                            </v-chip>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn
                variant="flat"
                style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px;"
                @click="edit_leads_dialog = false"
              >
                CLOSE
              </v-btn>
          </v-toolbar>
          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE NEW VISIT DETAILS
                  </v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" style="border-radius: 2px;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <v-img
                            :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')"
                            aspect-ratio="1" class="user_image_view"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="9" lg="10" xl="10">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">User Name:
                             </p>
                          <p class="font-weight-bold custom_page_component_main_title"
                             style="color: #05146F !important;">{{ selectedLead?.agent_name }}</p>
                        </div>
                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile:  </p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">
                            {{ selectedLead?.mobile_number }}</p>
                        </div>
                        <div class="d-flex mt-6" v-if="selectedLead">
                          <v-chip v-if="selectedLead.visited_status === 'VISITED' || selectedLead.visited_status === 'COMPLETED'" class="custom_green_chip"
                                  variant="outlined" style="border-radius: 2px;">
                            <v-icon>mdi-check-circle-outline</v-icon> {{ formatCleanText(selectedLead.visited_status) }}
                          </v-chip>
                          <v-chip v-else class="custom_red_chip"
                                  variant="outlined" style="border-radius: 2px;">
                            <v-icon>mdi-close</v-icon> {{ formatCleanText(selectedLead.visited_status || 'PENDING') }}
                          </v-chip>
                          
                          <v-divider class="mx-3" vertical></v-divider>
                          
                          <v-chip v-if="selectedLead.crm_status === 'CREATED'" class="custom_green_chip"
                                  variant="outlined" style="border-radius: 2px;">
                            <v-icon>mdi-check-circle-outline</v-icon> CRM ENTRY   {{ formatCleanText(selectedLead.crm_status) }}
                          </v-chip>
                          <v-chip v-else class="custom_red_chip"
                                  variant="outlined" style="border-radius: 2px;">
                            <v-icon>mdi-close</v-icon> CRM ENTRY   {{ formatCleanText(selectedLead.crm_status || 'NOT CREATED') }}
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn class="custom_btn_primary" size="large" variant="outlined" @click="updateLead()" style="border-radius: 2px;">UPDATE
                        NEW VISIT
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row v-if="selectedLead">
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field
                        v-model="selectedLead.lead_title" :disabled="selectedLead.visited_status === 'VISITED'"
                        class="px-3 custom_input_field_color"
                        label="New Visit Title *" placeholder="Type title here" variant="outlined" density="comfortable"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-autocomplete
                        v-model="selectedLead.lead_main_category" :disabled="true" :items="categories"
                        :loading="mainFilterLoading" density="comfortable"
                        class=" px-3 custom_input_field_color" label="Main Category *" readonly variant="outlined"
                        item-text="main_filter" item-value="id"
                        @update:modelValue="fetchSubCategories(selectedLead.lead_main_category)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-autocomplete
                        v-model="selectedLead.lead_sub_category" :disabled="true" :items="subCategories"
                        :loading="subFilterLoading" density="comfortable"
                        class=" px-3 custom_input_field_color" label="Sub Category *" readonly variant="outlined"
                        item-text="sub_filter" item-value="id"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-autocomplete
                        v-model="selectedLead.province" :disabled="true" :items="provinces" :loading="mDistrictLoading"
                        item-text="label" item-value="value" label="Province *" placeholder="Select province" readonly
                        variant="outlined" density="comfortable" @update:modelValue="getAllDistrictAccProv"
                        class="mt-2 px-3 custom_input_field_color"
                    ></v-autocomplete>
                    </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-autocomplete class="mt-2 px-3 custom_input_field_color" density="comfortable"
                                    v-model="selectedLead.agent_name"
                                    :disabled="selectedLead.visited_status === 'VISITED'" :items="agentProvinceWise"
                                    item-title="name" item-value="name" label="Assign Agent *"
                                    placeholder="Select agent" variant="outlined"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.district" :disabled="isDisabledDistrictList"
                                    :items="districts" :loading="mDistrictLoading"
                                    item-text="label" item-value="value" label="District" placeholder="Select district"
                                    density="comfortable"
                                    readonly variant="outlined" @update:modelValue="getAllDsd"
                                    class="mt-2 px-3 custom_input_field_color"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.dsd" :disabled="isDisabledDSDLIST" :items="dsdList"
                                    :loading="mDSDLoading"
                                    item-text="label" item-value="value" label="DSD" placeholder="Select divisional"
                                    readonly density="comfortable"
                                    variant="outlined" @update:modelValue="getAllGnd"
                                    class="mt-2 px-3 custom_input_field_color"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.gnd" :disabled="isDisabledGNDList" :items="gndList"
                                    :loading="mDSDLoading"
                                    label="GND" placeholder="Select GND" readonly variant="outlined"
                                    class="mt-2 px-3 custom_input_field_color"
                                    @update:modelValue="loadLeadsList(lead.mainCategory, lead.subCategory)"
                                    density="comfortable"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-date-input v-model="assignDateObject" :disabled="selectedLead.visited_status === 'VISITED'"
                                  label="Assign Date *" persistent-placeholder
                                  variant="outlined" density="comfortable" class="px-3 custom_input_field_color"
                                  prepend-icon="" prepend-inner-icon="$calendar"
                    ></v-date-input>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-row class="px-3">
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title" style="opacity: 0.6">Type Description </p>
                        <v-divider class="mt-4 mb-3"></v-divider>
                        <v-card class="mt-5" elevation="1" border="sm opacity-1" style="border-radius: 2px;" max-height="355"
                                min-height="355">
                          <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                          <v-divider></v-divider>
                          <Editor v-model="selectedLead.lead_description" :defaultConfig="editorConfig" :mode="mode"
                                  @onCreated="handleCreated"/>
                        </v-card>
                      </v-col>
                    </v-row>
                    </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="deleteLeadDialog" id="app_lead_list" max-height="500" max-width="500" persistent
                @update:model-value="resetDialogState">
        <v-card style="border-radius: 2px;">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat style="border-radius: 2px;">
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE NEW VISIT</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="deleteLeadDialog = false; resetDialogState()" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>
            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                    Do you want to delete this New Visit?
                </v-card-title>
                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  <span v-if="visited_count > 0">
              This new visit cannot be deleted because it has {{ visited_count }} associated data in the following tables. Please remove the associations first.
            </span>
                  <span v-else>
              This new visit will be deleted immediately. Once deleted, it can no longer be used for any purpose.
            </span>
                </p>
                <v-divider class="mt-4"></v-divider>
                <div v-if="visited_count > 0">
                  <div class="text-body-2 mt-4 text-justify"><strong>New Visited Count:</strong> {{ visited_count }}
                  </div>
                  <div class="text-body-2 text-justify"><strong>New Visit Agent:</strong> {{ agent_name }} / {{ reg_num }}
                  </div>
                  <div class="text-body-2 text-justify"><strong>New Visit Assign Date:</strong> {{ assign_date }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit ID:</strong> {{ LeadID }}</div>
                </div>
                <v-divider class="mt-4"></v-divider>
                <div class="float-end mt-4 ">
                  <v-btn
                      color="red"
                      @click="deleteItem"
                      :disabled="salesLeadList.length > 0"
                      style="border-radius: 2px;"
                  >
                    DELETE
                  </v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="deleteLeadDialog = false ; resetDialogState()" style="border-radius: 2px;">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="rejectDialog" max-width="500" persistent>
        <v-card style="border-radius: 2px;">
          <v-toolbar color="red-darken-2" dark dense>
            <v-toolbar-title class="text-white">Reject New Visit</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="rejectDialog = false" color="white"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <p class="mb-3 text-body-1">Are you sure you want to reject this new visit request? Please provide a reason.</p>
            <v-textarea v-model="rejectReason" label="Reason for Rejection" variant="outlined" rows="4" required></v-textarea>
          </v-card-text>
          <v-card-actions class="pb-4 pr-4">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" @click="rejectDialog = false" style="border-radius: 2px;">Cancel</v-btn>
            <v-btn color="red-darken-2" variant="flat" class="text-white ml-2" @click="submitRejectLead" style="border-radius: 2px;">Reject</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="approveDialog" max-width="500" persistent>
        <v-card style="border-radius: 2px;">
          <v-toolbar color="green-darken-2" dark dense>
            <v-toolbar-title class="text-white">Approve New Visit</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="approveDialog = false" color="white"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <p class="mb-3 text-body-1">Are you sure you want to approve this new visit request?</p>
          </v-card-text>
          <v-card-actions class="pb-4 pr-4">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" @click="approveDialog = false" style="border-radius: 2px;">Cancel</v-btn>
            <v-btn color="green-darken-2" variant="flat" class="text-white ml-2" @click="submitApproveLead" style="border-radius: 2px;">Approve</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" location="top right" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import {getPermissions} from "@/plugins/permissions";
import DOMPurify from 'dompurify';

import '@wangeditor/editor/dist/css/style.css';
import {i18nChangeLanguage} from '@wangeditor/editor';

i18nChangeLanguage('en')
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {onBeforeUnmount, ref, shallowRef, onMounted} from 'vue'

export default {
  components: {
    Editor,
    Toolbar,
  },
  setup() {
    const editorRef = shallowRef()
    const valueHtml = ref('<p></p>')

    onMounted(() => {
      setTimeout(() => {
        valueHtml.value = '<p></p>'
      }, 1500)
    })

    const toolbarConfig = {toolbarKeys: ['bold', 'italic', 'underline', 'through']}
    
    const editorConfig = {
      placeholder: 'Type here...',
      hoverbarKeys: {
        text: { menuKeys: [] },
        link: { menuKeys: [] },
        image: { menuKeys: [] }
      }
    }

    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const handleCreated = (editor) => {
      editorRef.value = editor
    }

    return {
      editorRef,
      mode: 'simple',
      valueHtml,
      toolbarConfig,
      editorConfig,
      handleCreated
    };
  },
  name: 'LeadsList',
  data() {
    return {
      mainSearch: '',
      salesLeadList: [],
      visited_count: 0,
      agent_name: '',
      reg_num: '',
      LeadID: '',
      assign_date: '',
      reminderMessage: '',
      UserResponseData: {
        email: '',
      },
      imageURL: "",
      centerLoading: false,
      uniqueAreas: [],
      uniqueSalesReps: [],
      headers: [
        { title: 'NEW VISIT TITLE', value: 'lead_title', sortable: true },
        { title: 'INSTITUTE NAME', value: 'institute_name', sortable: true },
        { title: 'SALES REP NAME', value: 'salesRep_name', sortable: true },
        { title: 'AREA', value: 'area_code', sortable: true },
        { title: 'ASSIGN DATE', value: 'assign_date', sortable: true },
        { title: 'ACTION', value: 'actions', sortable: false }
      ],
      items: [],
      page: 1,
      itemsPerPage: 10,
      filters: {
        salesRep_name: [],
        area_code: [],
      },
      assignDate: null,
      view_leads_dialog: false,
      edit_leads_dialog: false,
      assignDateObject: new Date(),
      deleteLeadDialog: false,
      deleteLeadListEditDialog: false,
      reminderDialog: false,
      reminderDialogNew: false,
      rejectDialog: false,
      approveDialog: false,
      rejectReason: '',
      leadToReject: null,
      leadToApprove: null,
      selectedItem: {},
      smsDialog: false,
      file: null,
      showLeadsCard: true,
      lead: {
        title: '',
        mainCategory: '',
        sub_category: '',
        province: '',
        district: '',
        description: '',
        dsd: '',
        gnd: '',
        assignAgent: '',
        assign_date: '',
      },
      headers_two: [
        {title: 'Institute Name', value: 'institute_name', sortable: true},
        {title: 'Address', value: 'address', sortable: true},
        {title: 'Status', value: 'visited_status', sortable: true},
      ],
      notVisitedOutletItem: [],
      selectedItems: [],
      selectAllOutlet: false,
      items_two: [],
      loading: false,
      assignDateMenu: false,
      selectedLeadId: null,
      selectedLead: null,
      selectedLeadEdit: null,
      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackVisible: false,
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },
      selectedCategory: null,
      selectAll: false,
      mainFilterLoading: false,
      subFilterLoading: false,
      mDistrictLoading: false,
      mDSDLoading: false,
      mGNDLoading: false,
      provinces: [],
      districts: [],
      dsdList: [],
      gndList: [],
      isDisabledProvinceList: false,
      isDisabledDistrictList: false,
      isDisabledDSDLIST: false,
      isDisabledGNDList: false,
      selectedDistrict: [],
      selectedProvince: "",
      selectedDSD: [],
      selectedGND: [],
      agents: [],
      agentProvinceWise: [],
      categories: [],
      subCategories: [],
      allCategories: [],
      permissions: {},
      mainGroup: {},
      geoJsonLayers: [],
    };
  },
  computed: {
    filteredItems() {
      if (!this.items || this.items.length === 0) return [];
      
      const selectedDateRange = this.getSelectedDateRange();

      return this.items.filter((item) => {
        let matchesDate = true;
        if (selectedDateRange) {
          const routeDate = this.formatDateForComparison(item.assign_date);
          matchesDate = !!routeDate && routeDate >= selectedDateRange.start && routeDate <= selectedDateRange.end;
        }

        if (this.mainSearch) {
          const searchLower = this.mainSearch.toLowerCase();
          const matchesSearch = 
            (item.lead_title && item.lead_title.toLowerCase().includes(searchLower)) ||
            (item.institute_name && item.institute_name.toLowerCase().includes(searchLower)) ||
            (item.salesRep_name && item.salesRep_name.toLowerCase().includes(searchLower)) ||
            (item.address && item.address.toLowerCase().includes(searchLower)) ||
            (item.area_code && item.area_code.toLowerCase().includes(searchLower));
          if (!matchesSearch) return false;
        }

        if (this.filters.salesRep_name && this.filters.salesRep_name.length) {
          if (!this.filters.salesRep_name.includes(item.salesRep_name)) return false;
        }

        if (this.filters.area_code && this.filters.area_code.length) {
          if (!this.filters.area_code.includes(item.area_code)) return false;
        }

        return matchesDate;
      });
    }
  },
  created() {
    this.imageURL = process.env.VUE_APP_IMAGE_PUBLIC_URL;
  },
  mounted() {
    const dashboardId = 3;
    this.permissions = getPermissions(dashboardId);
    this.fetchDataintoTable();
    this.fetchMainCategories();
    this.getAllProvinces();
    this.fetchAreas();
  },
  methods: {
    fetchAreas() {
      const token = localStorage.getItem("token");
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/area-allList`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then((response) => {
        if (response.data && response.data.success) {
          this.uniqueAreas = response.data.data.map(area => ({
            title: `${area.area_code} | ${area.description}`,
            value: area.area_code
          }));
        }
      }).catch(error => {
        console.error("Error fetching areas", error);
      });
    },

    formatDateForComparison(date) {
      if (!date) return null;

      if (typeof date === 'string') {
        const trimmedDate = date.trim();
        const dateOnlyMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnlyMatch) return `${dateOnlyMatch[1]}-${dateOnlyMatch[2]}-${dateOnlyMatch[3]}`;

        const isoDateMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})T/);
        if (isoDateMatch) return `${isoDateMatch[1]}-${isoDateMatch[2]}-${isoDateMatch[3]}`;
      }

      const parsedDate = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return null;

      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getSelectedDateRange() {
      if (!this.assignDate) return null;

      const selectedValues = (Array.isArray(this.assignDate) ? this.assignDate : [this.assignDate])
        .filter(Boolean)
        .map((date) => this.formatDateForComparison(date))
        .filter(Boolean);

      if (selectedValues.length === 0) return null;

      selectedValues.sort();

      return {
        start: selectedValues[0],
        end: selectedValues[selectedValues.length - 1]
      };
    },

    clearAssignDate() {
      this.assignDate = null;
    },

    formatCleanText(text) {
      if (!text) return '';
      let str = String(text);
      if (str.toUpperCase() === 'NOT_COMPLETE') return 'Not Completed';
      if (str.toUpperCase() === 'NOT_VISITED') return 'Not Visited';
      
      let cleaned = str.replace(/[_,-]/g, ' ').replace(/\s+/g, ' ').trim();
      return cleaned.split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join(' ');
    },
    toggleSelectAllOutletItem() {
      if (this.selectAllOutlet) {
        this.selectedItems = this.notVisitedOutletItem.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    getSanitizedHTML(html) {
      if(!html) return "";
      return DOMPurify.sanitize(html);
    },
    convertToPlainText(html) {
      const sanitizedHTML = this.getSanitizedHTML(html);
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sanitizedHTML;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    handleInput(value) {
      if (this.selectedItem.not_visited_leads && this.selectedItem.not_visited_leads.length > 0) {
        this.selectedItem.not_visited_leads[0].not_visited_reason = value;
      }
    },
    handleDateChange(newValue) {
      if (newValue) {
        const parsedDate = new Date(newValue);
        if (!isNaN(parsedDate)) {
          this.selectedLead.assign_date = parsedDate.toISOString().split('T')[0];
        } else {
          console.error('Invalid date selected');
        }
      }
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    applyFormat(format) {
      if (format === 'italic') {
        this.textareaStyles.fontStyle =
            this.textareaStyles.fontStyle === 'italic' ? 'normal' : 'italic';
      } else if (format === 'bold') {
        this.textareaStyles.fontWeight =
            this.textareaStyles.fontWeight === 'bold' ? 'normal' : 'bold';
      } else if (format === 'underline') {
        this.textareaStyles.textDecoration =
            this.textareaStyles.textDecoration === 'underline' ? 'none' : 'underline';
      } else if (format === 'color') {
        this.textareaStyles.color = this.selectedColor;
      }
    },
    setAlignment(align) {
      this.textareaStyles.textAlign = align;
    },
    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },
    exportExcel() {
      function stripHTMLTags(input) {
        if(!input) return "";
        const doc = new DOMParser().parseFromString(input, 'text/html');
        return doc.body.textContent || "";
      }
      
      const tableData = this.filteredItems.map((item, index) => {
        if (!item) return {};
        return {
          'NO': index + 1,
          'NEW VISIT TITLE': item.lead_title || '',
          'INSTITUTE NAME': item.institute_name || 'N/A',
          'DESCRIPTION': stripHTMLTags(item.discription || ''),
          'SALES REP NAME': item.salesRep_name || '',
          'AREA': item.area_code || '',
          'ASSIGN DATE': item.assign_date || '',
          'STATUS': this.formatCleanText(item.lead_status || ''),
        };
      });
      
      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const columnWidths = [
        {wpx: 50}, {wpx: 150}, {wpx: 150}, {wpx: 200}, {wpx: 120}, {wpx: 100}, {wpx: 100}, {wpx: 100},
      ];
      worksheet['!cols'] = columnWidths;
      Object.keys(worksheet).forEach(cell => {
        if (cell.startsWith('A1')) {
          worksheet[cell].s = {
            font: {bold: true, color: {rgb: "FFFFFF"}},
            fill: {fgColor: {rgb: "1F4E78"}},
            alignment: {horizontal: "center"},
          };
        }
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'New Visit for Approval');
      XLSX.writeFile(workbook, 'new_visits_for_approval.xlsx', { cellStyles: true });
    },
    async exportPDF() {
      this.centerLoading = true;
      const doc = new jsPDF();
      
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text('New Visit for Approval', 14, 10);
      
      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");
      doc.text('A comprehensive list of New Visit data for approvals', 14, 28);
      
      const data = this.filteredItems;
      if (!data || data.length === 0) {
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text("No data available.", 14, 40);
        doc.save('new_visits_for_approval.pdf');
        this.centerLoading = false;
        return;
      }
      
      const tableData = data.map((row, idx) => [
        idx + 1,
        row.lead_title || '',
        row.institute_name || 'N/A',
        row.salesRep_name || '',
        row.area_code || '',
        row.assign_date || '',
        this.formatCleanText(row.lead_status || '')
      ]);

      const tableColumns = [
        {header: 'NO', dataKey: 'index'},
        {header: 'NEW VISIT TITLE', dataKey: 'lead_title'},
        {header: 'INSTITUTE NAME', dataKey: 'institute_name'},
        {header: 'SALES REP NAME', dataKey: 'salesRep_name'},
        {header: 'AREA', dataKey: 'area_code'},
        {header: 'ASSIGN DATE', dataKey: 'assign_date'},
        {header: 'STATUS', dataKey: 'status'}
      ];

      doc.autoTable({
        head: [tableColumns.map(col => col.header)],
        body: tableData,
        startY: 35,
        startX: 5,
        headStyles: {fillColor: [41, 128, 185], textColor: [255, 255, 255], fontSize: 7},
        bodyStyles: {fontSize: 7},
        columnStyles: {
          0: {cellWidth: 8},
          1: {cellWidth: 35},
          2: {cellWidth: 35},
          3: {cellWidth: 30},
          4: {cellWidth: 20},
          5: {cellWidth: 22},
          6: {cellWidth: 20},
        },
        styles: {cellPadding: 3, overflow: 'linebreak'},
        theme: 'striped',
        didDrawPage: function (data) {
          let pageSize = doc.internal.pageSize;
          let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text('Page ' + doc.internal.getNumberOfPages(), data.settings.margin.left, pageHeight - 10);
        },
      });

      doc.save('new_visits_for_approval.pdf');
      this.centerLoading = false;
    },
    fetchDataintoTable() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");
      this.loading = true;
      
      const url = `${process.env.VUE_APP_API_BASE_URL}/api/v1-selected-leads?approval_status=PENDING&userId=${userId}`;

      axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        params: {
          size: 1000000
        }
      }).then((response) => {
        if (response.data && response.data.success && Array.isArray(response.data.data)) {
            let fetchedData = response.data.data;
            
            let flatList = fetchedData.map(item => {
                let leadObj = Object.assign({}, item);
                leadObj.specific_sub_lead_id = item.id; 
                leadObj.parent_lead_id = item.lead_id;
                leadObj.unique_key = item.id; 
                leadObj.institute_name = item.institute_name || item.address || 'N/A';
                return leadObj;
            });

            this.items = _.orderBy(flatList, ['id'], ['desc']);
            
            const extractedReps = new Set(this.items.map(item => item.salesRep_name).filter(Boolean));
            this.uniqueSalesReps = Array.from(extractedReps);
        } else {
            this.items = [];
        }
      }).catch((error) => {
        console.error("Fetch Data Error:", error);
        this.items = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    backPageRoute() {
      this.$router.back();
    },
    homeReload() {
      window.location.href = '/dashboard';
    },
    async viewItem(item) {
      try {
        const rawItem = item.raw || item;
        this.selectedLead = { 
          ...rawItem, 
          selected_leads: [{
            id: rawItem.specific_sub_lead_id,
            institute_name: rawItem.institute_name,
            address: rawItem.address || 'N/A',
            visited_status: rawItem.visited_status || 'PENDING',
            crm_status: rawItem.crm_status || 'PENDING'
          }],
          discription: rawItem.discription || '',
          sales_rep_mobile: rawItem.sales_rep_mobile?.mobile_number || rawItem.sales_rep_mobile || ''
        };
        this.view_leads_dialog = true;
        const token = localStorage.getItem('token');
        if (rawItem.parent_lead_id) {
          const leadDetailUrl = `${process.env.VUE_APP_API_BASE_URL}/api/v1/lead/${rawItem.parent_lead_id}`;
          const leadDetailResponse = await axios.get(leadDetailUrl, {
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
          });
          if (leadDetailResponse.data && leadDetailResponse.data.success) {
            const leadData = leadDetailResponse.data.data;
            this.selectedLead.discription = leadData.discription || this.selectedLead.discription;
            if (leadData.sales_rep_mobile && leadData.sales_rep_mobile.mobile_number) {
              this.selectedLead.sales_rep_mobile = leadData.sales_rep_mobile.mobile_number;
            }
          }
        }
      } catch (error) {
        console.error('Error in viewItem function:', error);
      }
    },
    openApproveDialog(item) {
      const rawItem = item.raw || item;
      this.leadToApprove = rawItem;
      this.approveDialog = true;
    },
    async submitApproveLead() {
      this.centerLoading = true;
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const targetId = this.leadToApprove.specific_sub_lead_id || this.leadToApprove.id;
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/v1-selected-leads/${targetId}/approve`, { userId: parseInt(userId) }, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        this.showSnackbar('New Visit approved successfully', 'success');
        this.approveDialog = false;
        this.view_leads_dialog = false;
        this.fetchDataintoTable();
      } catch (error) {
        this.showSnackbar('Failed to approve new visit', 'error');
      } finally {
        this.centerLoading = false;
      }
    },
    openRejectDialog(item) {
      const rawItem = item.raw || item;
      this.leadToReject = rawItem;
      this.rejectReason = '';
      this.rejectDialog = true;
    },
    async submitRejectLead() {
      if (!this.rejectReason || this.rejectReason.trim() === '') {
        this.showSnackbar('Please provide a reason for rejection.', 'error');
        return;
      }
      this.centerLoading = true;
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const targetId = this.leadToReject.specific_sub_lead_id || this.leadToReject.id;
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/v1-selected-leads/${targetId}/reject`, { approval_reason: this.rejectReason, userId: parseInt(userId) }, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        this.showSnackbar('New Visit rejected successfully', 'success');
        this.rejectDialog = false;
        this.view_leads_dialog = false;
        this.fetchDataintoTable();
      } catch (error) {
        this.showSnackbar('Failed to reject new visit', 'error');
      } finally {
        this.centerLoading = false;
      }
    },
    updateLead() {
      if (!this.selectedLead.lead_title) {
        this.showSnackbar('New Visit Title is required.', 'error');
        return;
      }
      this.centerLoading = true;
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const assignDate = new Date(this.assignDateObject).toISOString().split('T')[0];
      const leadData = {
        leadsTitle: this.selectedLead.lead_title,
        leadId: this.selectedLead.id,
        area_code: this.selectedLead.area_code,
        assignAgent: this.selectedLead.salesRep_name,
        assignDate: assignDate,
        description: this.selectedLead.discription,
        userId,
      };
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/addLeads`, leadData, {
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'content-type': 'application/json', 'Authorization': `Bearer ${token}` },
      })
      .then(() => {
        this.showSnackbar("New Visit data was updated successfully!", "success");
        this.fetchDataintoTable();
        this.edit_leads_dialog = false;
      })
      .catch(() => {
        this.showSnackbar("Error!", "error");
      })
      .finally(() => {
        this.centerLoading = false;
      });
    },
    confirmDelete(item) {
      const rawItem = item.raw || item;
      this.selectedLeadId = rawItem.id;
      this.deleteLeadDialog = true;
    },
    deleteItem() {
      this.centerLoading = true;
      const token = localStorage.getItem('token');
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/v1/selected-leads/${this.selectedLeadId}`, {
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
      })
      .then(() => {
        this.showSnackbar("The New Visit Was Successfully Deleted", "success");
        this.deleteLeadDialog = false;
        this.fetchDataintoTable();
      })
      .catch(() => {
        this.showSnackbar("Failed to delete the new visit", "error");
      })
      .finally(() => {
        this.centerLoading = false;
      });
    },
    resetDialogState() {
      this.salesLeadList = [];
      this.visited_count = 0;
    },
    getAllProvinces() {
      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary', {type: 'province'}, { headers: { 'content-type': 'multipart/form-data' } })
      .then(response => { if (response.data.http_status === 'success') this.provinces = response.data; });
    },
    getAllDistrictAccProv(province) {
      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary', {type: 'district', value: province}, { headers: { 'content-type': 'multipart/form-data' } })
      .then(response => { if (response.data.http_status === 'success') this.districts = response.data.data; });
    },
    getAllDsd(district) {
      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary', {type: 'dsd', value: district}, { headers: { 'content-type': 'multipart/form-data' } })
      .then(response => { if (response.data.http_status === 'success') this.dsdList = response.data.data; });
    },
    getAllGnd(dsd) {
      axios.post('https://geobizz.tech/api/gis/sortAdminBoundary', {type: 'gnd', value: dsd}, { headers: { 'content-type': 'multipart/form-data' } })
      .then(response => { if (response.data.http_status === 'success') this.gndList = response.data.data; });
    },
    async fetchMainCategories() {
      try {
        const response = await axios.post('https://geobizztech.celata.org/geoapi/gis/getCategories', { org_code: 'SFA_Backend', category: 'Community data', type: 'Spatial', country: 'SriLanka', user: '' });
        if (response.data && response.data.dataset) {
          this.allCategories = response.data.dataset;
          this.mainGroup = _.groupBy(this.allCategories, 'main_filter');
          this.categories = Object.keys(this.mainGroup);
        }
      } catch (error) { console.error('Error fetching categories'); }
    },
    fetchSubCategories(dataset) {
      let sub_filter = this.allCategories.filter(cat => cat.main_filter === dataset).map(cat => cat.sub_filter);
      this.subCategories = sub_filter.filter(Boolean).sort();
    },
    loadLeadsList(m, s) { console.log(m, s); }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/lead_management/leads_list.scss" as *;
.custom_font_color_view { color: #2196F3 !important; font-weight: 500; }
.custom_font_color_delete { color: #F44336 !important; font-weight: 500; }
</style>